import { makeAutoObservable, runInAction } from 'mobx'
import decorationMobx from '@mobx/app/decoration.mobx'
import { MemberApi } from '@api/index'
import { each } from '@dt/fe-utils/dist/lodash'
class PointCardStore {
  constructor () {
    makeAutoObservable(this, {}, { autoBind: true })
  }
  pointCardList: IPointCard[] = []
  async initData () {
    this.pointCardList = []
  }
  // 获取集点卡列表
  async getPointCardList () {
    let res: any[]
    try {
      res = await MemberApi.collectPointActivity()
    } catch (error) { }
    runInAction(() => {
      const setPointMarket: any = decorationMobx.mktDecorates.setPointMarket
      let sortArr: any[] = []
      let otherArr: any[] = []
      each(res, (item: any) => {
        item.extra = item.extra || {}
        if (setPointMarket && setPointMarket.includes(item.activityId)) {
          sortArr.push(item)
        } else {
          otherArr.push(item)
        }
      })
      res && (this.pointCardList = [...sortArr.sort((a: any, b: any) => {
        return setPointMarket.indexOf(a.activityId) - setPointMarket.indexOf(b.activityId)
      }), ...otherArr])
    })
    return res
  }
  // 获取集点卡详情
  async getPointCardDetail (activityId: number) {
    let res
    try {
      res = await MemberApi.collectPointActivity(activityId)
    } catch (error) { }
    return res
  }
}

export default new PointCardStore()
